import { createContext } from "react";
import getCountries from "../services/getCountries";
import getDepartments from "../services/getDepartments";
import getProvinces from "../services/getProvinces";
import getLocalities from "../services/getLocalities";
import getCensusLocalities from "../services/getCensusLocalities";
import getMunicipalities from "../services/getMunicipalities";
import toast from "react-hot-toast";

const LocationContext = createContext();

const LocationProvider = ({ children }) => {
  const getCountriesFunc = async () => {
    try {
      return await getCountries();
    } catch (error) {
      toast.error('Error al obtener los paises')
    }
  }

  const getDepartmentsFunc = async () => {
    try {
      return await getDepartments();
    } catch (error) {
      toast.error('Error al obtener los departamentos')
    }
  }

  const getLocalidadesFunc = async () => {
    try {
      return await getLocalities();
    } catch (error) {
      toast.error('Error al obtener las localidades')
    }
  }

  const getProvincesFunc = async () => {
    try {
      return await getProvinces();
    } catch (error) {
      toast.error('Error al obtener las provincias')
    }
  }

  const getMunicipalitiesFunc = async () => {
    try {
      return await getMunicipalities();
    } catch (error) {
      toast.error('Error al obtener los municipios')
    }
  }

  const getCensusLocalitiesFunc = async () => {
    try {
      return await getCensusLocalities();
    } catch (error) {
      toast.error('Error al obtener los municipios')
    }
  }

  const searchLocalidades = async (prov_id) => {
    let concatLocalidades = [];
    const departments = await getDepartmentsFunc();
    const localities = await getLocalidadesFunc();
    const filteredDepartments = departments?.department?.filter(
      (department) => department.department_province_id === prov_id
    );

    filteredDepartments.map((dep) =>
      concatLocalidades.push({
        locality_id: dep.department_id,
        locality_name: dep.department_name,
        locality_full_name: dep.department_full_name,
        locality_province_id: dep.department_province_id,
        localitie_type: "departments",
      })
    );

    const filteredLocalities = localities.locality?.filter(
      (locality) => locality.localities_province_id === prov_id
    );

    filteredLocalities.map((locality) =>
      concatLocalidades.push({
        locality_id: locality.localities_id,
        locality_name: locality.localities_name,
        locality_full_name: null,
        locality_province_id: locality.localities_province_id,
        localitie_type: "localities",
      })
    );
    const municipalities = await getMunicipalitiesFunc();
    const filteredMunicipalities = municipalities.municipality?.filter(
      (municipality) => municipality.municipality_province_id === prov_id
    );

    filteredMunicipalities.map((municipality) =>
      concatLocalidades.push({
        locality_id: municipality.municipality_id,
        locality_name: municipality.municipality_name,
        locality_full_name: municipality.municipality_fullname,
        locality_province_id: municipality.municipality_province_id,
        localitie_type: "municipalities",
      })
    );
    const censusLocalities = await getCensusLocalitiesFunc();
    const filteredCensusLoc = censusLocalities.censusLocality?.filter(
      (censusLoc) => censusLoc.census_localities_province_id === prov_id
    );

    filteredCensusLoc.map((censusLoc) =>
      concatLocalidades.push({
        locality_id: censusLoc.census_localities_id,
        locality_name: censusLoc.census_localities_name,
        locality_full_name: null,
        locality_province_id: censusLoc.census_localities_province_id,
        localitie_type: "census_localities",
      })
    );

    concatLocalidades.sort((a, b) => {
      return a.locality_name.localeCompare(b.locality_name);
    });

    return concatLocalidades
  };

  return (
    <LocationContext.Provider
      value={{
        getCountriesFunc,
        getProvincesFunc,
        searchLocalidades,
      }}
    >
      {children}
    </LocationContext.Provider>
  );
};

export { LocationProvider };

export default LocationContext;
